"use strict";
/* eslint-disable no-console */
Object.defineProperty(exports, "__esModule", { value: true });
exports.logConsoleMessage = exports.ConsoleMessageLevels = void 0;
var ConsoleMessageLevels;
(function (ConsoleMessageLevels) {
    ConsoleMessageLevels["ERROR"] = "error";
    ConsoleMessageLevels["WARN"] = "warn";
})(ConsoleMessageLevels = exports.ConsoleMessageLevels || (exports.ConsoleMessageLevels = {}));
var ConsoleTitleSyles = {
    error: 'padding: 3px; background-color: pink; margin: 0; color: red;',
    warn: 'padding: 3px; background-color: gold; margin: 0; color: black;'
};
var ConsoleMessageStyles = {
    error: ConsoleTitleSyles.error,
    warn: 'padding: 3px;',
    info: 'padding: 3px; background-color: white; color: blue;'
};
var boldMessageStyle = function (style) { return "font-weight: bold; " + style; };
var logConsoleMessage = function (title, messageLevel, message, solution, versionMsg, removalMsg) {
    var _a;
    var titleStyle = ConsoleTitleSyles[messageLevel];
    var primaryMessageStyle = ConsoleMessageStyles[messageLevel];
    var secondaryMessageStyle = ConsoleMessageStyles.info;
    if (/[^(test|production)]/.test((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV)) {
        title && console.group("%c[FERRIS] [" + title.toUpperCase() + "]", titleStyle);
        message && console.log(message, boldMessageStyle(primaryMessageStyle), primaryMessageStyle);
        solution && console.log(solution, boldMessageStyle(secondaryMessageStyle), secondaryMessageStyle);
        versionMsg && console.log(versionMsg, boldMessageStyle(secondaryMessageStyle), secondaryMessageStyle);
        removalMsg && console.log(removalMsg, boldMessageStyle(secondaryMessageStyle), secondaryMessageStyle);
        title && console.groupEnd();
    }
    //TODO: LOG FOUND DEPRECATION TO SPLUNK (DEP: epc-logger)
};
exports.logConsoleMessage = logConsoleMessage;
